module.exports = __webpack_public_path__ + "static/img/areaB_04.572583a.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/areaB_04.png
// module id = 1265
// module chunks = 1